module.exports = __webpack_public_path__ + "img/discount.80f0e4c0.svg";